import { render, staticRenderFns } from "./StatusButtons.vue?vue&type=template&id=6624f83e&scoped=true"
import script from "./StatusButtons.vue?vue&type=script&lang=ts"
export * from "./StatusButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624f83e",
  null
  
)

export default component.exports